import { render, staticRenderFns } from "./ChallengeItem.vue?vue&type=template&id=02431852&scoped=true&"
import script from "./ChallengeItem.vue?vue&type=script&lang=js&"
export * from "./ChallengeItem.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeItem.vue?vue&type=style&index=0&id=02431852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02431852",
  null
  
)

export default component.exports